class NewsletterPopup extends HTMLElement {
    constructor() {
        super();
        this.popup = this.querySelector('.newsletter-popup');
        this.closeButtons = this.querySelectorAll('.newsletter-popup__close, .newsletter-popup__close-button');
        this.form = this.querySelector('form');
        this.checkbox = this.querySelector('input[name="policy_confirmed"]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.storageType = this.dataset.storage || 'none';
        this.isSuccessState = this.querySelector('.newsletter-popup__success') !== null;

        // Always set up close button listeners
        this.setupCloseButtons();

        // Check if this is a success state (form posted successfully)
        if (this.isSuccessState) {
            // Mark as subscribed and show the popup
            this.setSubscribed();
            return;
        }

        // Check if popup should show
        if (this.shouldShowPopup()) {
            this.init();
        }
    }

    setupCloseButtons() {
        this.closeButtons.forEach(button => {
            button.addEventListener('click', () => this.close());
        });

        // Also handle clicking outside the content to close
        this.popup?.addEventListener('click', (e) => {
            if (e.target === this.popup) {
                this.close();
            }
        });
    }

    getStorage() {
        if (this.storageType === 'localStorage') {
            return localStorage;
        } else if (this.storageType === 'sessionStorage') {
            return sessionStorage;
        }
        return null;
    }

    shouldShowPopup() {
        const storage = this.getStorage();

        if (storage) {
            const subscribed = storage.getItem('newsletter_popup_subscribed');
            if (subscribed === 'true') return false;

            const dismissed = storage.getItem('newsletter_popup_dismissed');
            if (dismissed) {
                const dismissedDate = new Date(parseInt(dismissed));
                const now = new Date();
                const diffTime = Math.abs(now - dismissedDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                // If dismissed less than 7 days ago, don't show
                if (diffDays < 7) return false;
            }
        }

        // Check if already subscribed via URL param
        if (window.location.href.includes('customer_posted=true')) {
            this.setSubscribed();
            return false;
        }

        return true;
    }

    init() {
        // Delay opening
        const delay = parseInt(this.dataset.delay || 5) * 1000;
        setTimeout(() => this.open(), delay);

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                // Policy check
                if (this.checkbox && !this.checkbox.checked) {
                    e.preventDefault();
                    alert('Please agree to the privacy policy.');
                    return;
                }

                // Loading state
                if (this.submitButton) {
                    const textSpan = this.submitButton.querySelector('.submit-text');
                    const loadingSpan = this.submitButton.querySelector('.loading-state');

                    if (textSpan) textSpan.classList.add('hidden');
                    if (loadingSpan) loadingSpan.classList.remove('hidden');

                    this.submitButton.style.cursor = 'wait';
                }
            });
        }
    }

    open() {
        this.popup.classList.add('is-visible');
    }

    close() {
        this.popup.classList.remove('is-visible');
        this.setDismissed();
    }

    setDismissed() {
        const storage = this.getStorage();
        if (storage) {
            storage.setItem('newsletter_popup_dismissed', Date.now().toString());
        }
    }

    setSubscribed() {
        const storage = this.getStorage();
        if (storage) {
            storage.setItem('newsletter_popup_subscribed', 'true');
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);
